import { create } from 'zustand';

type GlobalFiltersStore = {
  isGlobalFiltersDrawerOpen: boolean;
  openGlobalFiltersDrawer: () => void;
  closeGlobalFiltersDrawer: () => void;
};

const useGlobalFiltersState = create<GlobalFiltersStore>()((set) => ({
  isGlobalFiltersDrawerOpen: false,
  openGlobalFiltersDrawer: () => set({ isGlobalFiltersDrawerOpen: true }),
  closeGlobalFiltersDrawer: () => set({ isGlobalFiltersDrawerOpen: false }),
}));

export const useV2ContentFiltersStore = () => {
  return useGlobalFiltersState();
};
